module.exports = __webpack_public_path__ + "images/e1bfeb0628a7a5ead087c6778d8a3c35-silver_badge.png";